import React, { useEffect } from 'react';
import useAuth from 'src/hooks/useAuth';
import LoadingScreen from 'src/components/LoadingScreen';

const home_url = process.env.REACT_APP_DOMAIN;

// ----------------------------------------------------------------------

// Real /logout. Both this app and the office app redirect to `${home_url}/logout`
// when a token login fails, but no route ever handled it — so the browser landed
// on an unmatched path, rendered nothing (blank page) and, worse, the session was
// never cleared: the user looked logged out while still fully authenticated.
//
// This ends the session for real (redux logout + cart reset + firebase.signOut)
// and then sends the browser to a clean entry point.
function LogoutView() {
  const { logout } = useAuth();

  useEffect(() => {
    let done = false;

    const run = async () => {
      try {
        await logout();
      } catch (err) {
        // Never strand the user here — even a failed sign-out must land
        // somewhere usable rather than on a blank screen.
        console.error('logout failed', err);
      }
      if (!done) {
        window.location = home_url || '/';
      }
    };

    run();

    return () => { done = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LoadingScreen />;
}

export default LogoutView;
